import { render, staticRenderFns } from "./myBooking.vue?vue&type=template&id=20c56971&scoped=true&"
import script from "./myBooking.vue?vue&type=script&lang=js&"
export * from "./myBooking.vue?vue&type=script&lang=js&"
import style0 from "./myBooking.vue?vue&type=style&index=0&id=20c56971&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c56971",
  null
  
)

export default component.exports